import React, { useEffect, useState } from "react";
import "./HeaderComponent.css";
import MaitaiLogo from "./assets/maitai_logo_light_transparent.svg";

const HeaderComponent: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="header-container">
      <div className={`leftSection ${isMobile ? "mobile" : ""}`}>
        <img src={MaitaiLogo} className="logo-image" alt="Maitai Logo" />
      </div>
    </div>
  );
};

export default HeaderComponent;
